import { render, staticRenderFns } from "./FiltrosCadastroTeste.vue?vue&type=template&id=a5ce8382&"
import script from "./FiltrosCadastroTeste.vue?vue&type=script&lang=js&"
export * from "./FiltrosCadastroTeste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports